import React from 'react';
import { Form } from 'antd';
import ImageCropUpload from '../../ImageCropUpload';

export default function ImageCropFormField({ form, ...props }) {
    return (
        <Form.Item {...form}>
            <ImageCropUpload {...props} />
        </Form.Item>
    );
}